import { Card, CardContent, Typography } from "@mui/material";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip } from "recharts";

const formatCurrency = (value, currency) =>
  `${currency}${Number(value / 100 || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

const formatNumber = (value) => Number(value || 0).toLocaleString();

export default function HorizontalBarChart({ title, data, dataKey, currency }) {
  const isValue = dataKey === "value";

  return (
    <Card sx={{ borderRadius: 3 }}>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 2 }}>
          {title}
        </Typography>

        <ResponsiveContainer width="100%" height={320}>
          <BarChart data={data} layout="vertical" margin={{ left: 20 }}>
            <XAxis type="number" tick={false} axisLine={true} tickLine={false} />

            <YAxis type="category" dataKey="name" tick={{ fontSize: 13 }} />

            <Tooltip
              formatter={(value) =>
                isValue ? formatCurrency(value, currency) : formatNumber(value)
              }
            />

            <Bar dataKey={dataKey} fill="#111827" radius={[0, 6, 6, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
